import defaultPreferencesDialogTemplate from '../consts/default-preferences-template';
/*
 ** Mapping destinations to our categories we expose to the user
 ** this gets fired on saveConsent
 */
var mapCustomPreferences = function (destinations, preferences) {
    // object to store preferences for each destination
    var destinationPreferences = {};
    // object to store preferences for each category
    var customPreferences = preferences;
    // reference of all our possible categories
    var customCategories = defaultPreferencesDialogTemplate.categories;
    customCategories.forEach(function (category) {
        destinations.forEach(function (destination) {
            // if destination matches current category
            if (category.types.includes(destination.category)) {
                if (destinationPreferences[destination.id] !== false) {
                    destinationPreferences[destination.id] =
                        customPreferences[category.key];
                }
            }
        });
    });
    return {
        customPreferences: customPreferences,
        destinationPreferences: destinationPreferences,
    };
};
export default mapCustomPreferences;
